module.exports = __webpack_public_path__ + "static/media/00_paint_agd-zebra.8d06d2e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/00_paint_agd-zebra.jpg
// module id = 275
// module chunks = 0